import { Component, ElementRef, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { SuccessAccountCreatedComponent } from 'src/app/shared/modal/success-account-created/success-account-created.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { default as _rollupMoment } from 'moment';
import { ClubServicesService } from "src/app/shared/services/club-services.service";
import { SpinnerVisibilityService } from "ng-http-loader";
import { ManageOrderderService } from "src/app/shared/services/manage-orderder.service";
import { DatePipe } from '@angular/common';
import { chatbot } from 'src/assets/chatbot.js';
import { DateTime } from 'luxon';


import { Pipe, PipeTransform } from '@angular/core';
export interface clubDataType {
  id: string;
  name: string;
  location: string;
  imgPath: string;
  title: string;
  date: string;
  time: string;
}

export interface clubEventsDataType {
  eventTitle: string;
  eventDate: string;
  deliveryTime: string;
  teams: any;
  deliveryMethod: string,
  undeliveredCount: number,
  restaurantId: string,
  restaurantData: {
    address: string,
    city: string,
    countryCode: string,
    postalCode: string,
    province: string,
    restaurantName: string,
    logo: string;
    _id: string
  }
}

export const MY_FORMATS = {
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
  parse: {
    dateInput: 'LL',
  },
};


@Component({
  selector: 'app-organization-dash',
  templateUrl: './organization-dash.component.html',
  styleUrls: ['./organization-dash.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})


export class OrganizationDashComponent implements OnInit {
  repeatData: any[] = [1, 2, 3, 4];
  currentDate: any = new Date();
  checkedVal = false;
  productsList: any;
  currentTime: any = "";
  deliveryCheckboxSelected = false;
  pickupCheckboxSelected = false;
  EventList: clubEventsDataType[] = [];
  restaurantListNearBy: any;
  activeView: string = 'menu';
  search: any;
  UpcomingOrderList: any = [];
  config = {
    backdrop: true,
    ignoreBackdropClick: false,
    class: 'my-class myclass2',
    id: "profile"
  };



  configDel = {
    backdrop: true,
    ignoreBackdropClick: false,
    class: 'DeliveryModal',
    id: "profile"
  };

  formatEventDate(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "Aug 17, 2025"
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }

  formatEventTime(dt?: string | Date, useUTC = false): string {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';

    // e.g., "3:30 PM"
    return d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...(useUTC ? { timeZone: 'UTC' } : {})
    });
  }



  // date = new FormControl(moment());
  datepipe: DatePipe = new DatePipe('en-US')
  date = new Date();
  todayDate: Date = new Date();
  restaurantListByUser: any;
  // ********************************************************************************************
  // VARIABLE START
  selected: any;
  ProfileDetails: any;
  userType: any = false;
  selectRestaurant: boolean;

  private unsubscriber: Subject<void> = new Subject<void>();
  currentUser: any = localStorage.getItem("currentUser")

  playersDataList = [
    { name: "US game" },
    { name: "US game" }
  ];

  // ClubData: clubDataType[] = [
  //   {
  //     id: "1",
  //     name: "Chick-fil-A",
  //     location: "4476 George St, Sydenham ON K0H 2T0, Canada",
  //     imgPath: "../../../../assets/icon/club_icon.png",
  //     title: "US Game",
  //     date: "June 18, 2023",
  //     time: '01:00 pm'
  //   },
  //   {
  //     id: "2",
  //     name: "Chick-fil-A",
  //     location: "4476 George St, Sydenham ON K0H 2T0, Canada",
  //     imgPath: "../../../../assets/icon/club_icon.png",
  //     title: "US Game",
  //     date: "June 18, 2023",
  //     time: '01:00 pm'
  //   },
  //   {
  //     id: "3",
  //     name: "Chick-fil-A",
  //     location: "4476 George St, Sydenham ON K0H 2T0, Canada",
  //     imgPath: "../../../../assets/icon/club_icon.png",
  //     title: "US Game",
  //     date: "June 18, 2023",
  //     time: '01:00 pm'
  //   },
  //   {
  //     id: "4",
  //     name: "Chick-fil-A",
  //     location: "4476 George St, Sydenham ON K0H 2T0, Canada",
  //     imgPath: "../../../../assets/icon/club_icon.png",
  //     title: "US Game",
  //     date: "June 18, 2023",
  //     time: '01:00 pm'
  //   },
  //   {
  //     id: "5",
  //     name: "Chick-fil-A",
  //     location: "4476 George St, Sydenham ON K0H 2T0, Canada",
  //     imgPath: "../../../../assets/icon/club_icon.png",
  //     title: "US Game",
  //     date: "June 18, 2023",
  //     time: '01:00 pm'
  //   },
  //   {
  //     id: "6",
  //     name: "Chick-fil-A",
  //     location: "4476 George St, Sydenham ON K0H 2T0, Canada",
  //     imgPath: "../../../../assets/icon/club_icon.png",
  //     title: "US Game",
  //     date: "June 18, 2023",
  //     time: '01:00 pm'
  //   }
  // ]

  eventForm = this.fb.group({
    title: new FormControl('', [Validators.required]),
    date: new FormControl('', [Validators.required]),
    team: new FormControl('', [Validators.required]),
    comment: new FormControl(''),
    delivary: new FormControl('', [Validators.required]),
  })

  selectForm = this.fb.group({
    check: new FormControl('', [Validators.required]),
  })

  checkForm = this.fb.group({
    checkbox: new FormControl('', [Validators.required]),
  })

  teamList: any;
  modalRef: BsModalRef;
  disableRestaurantsNext: boolean = true;

  // VARIABLE END
  // ********************************************************************************************


  // ********************************************************************************************
  // DEFAULT START
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private csObj: CommonService,
    private toast: ToastrService,
    private dialogue: MatDialog,
    private router: Router,
    private clubService: ClubServicesService,
    private spinner: SpinnerVisibilityService,
    private manageOrdersServices: ManageOrderderService,

  ) { }

  delieveryCheckBoxText: string = '';

  onDeliveryCheckboxChange(e) {
    // e.target.checked==true
    if (e.checked == true) {
      this.deliveryCheckboxSelected = true;
      this.pickupCheckboxSelected = false;
      this.delieveryCheckBoxText = 'delivery';
    } else {
      this.deliveryCheckboxSelected = false;
      this.pickupCheckboxSelected = false;
      this.delieveryCheckBoxText = undefined;
    }
    // Uncheck the pickup checkbox when the delivery checkbox is checked
  }

  onPickupCheckboxChange(e) {
    // e.target.checked==true
    if (e.checked == true) {
      this.pickupCheckboxSelected = true;
      this.deliveryCheckboxSelected = false;
      this.delieveryCheckBoxText = 'pickup';
    } else {
      this.pickupCheckboxSelected = false;
      this.deliveryCheckboxSelected = false;
      this.delieveryCheckBoxText = undefined;
    }
    // Uncheck the delivery checkbox when the pickup checkbox is checked
  }

  successCreation() {
    const dialogRef = this.dialogue.open(SuccessAccountCreatedComponent, {
      hasBackdrop: true,
      disableClose: true,
      id: 'addEventId',
      data: {
        userType: {
          titleOne: 'Event Added Successfully!',
          text: "",
          imgPath: '../../../assets/icon/thumb.png',
          access: "eventsAdd"
        }
      },
    });
  }







  // formControlItem: FormControl = new FormControl('');
  //   maxTime: DateTime = DateTime.local().set({
  //     hour: 16,
  //   });
  //   minTime: DateTime = DateTime.local().set({
  //     hour: 14,
  //   });
  //   required: boolean = !1;

  // formControlItem: FormControl = new FormControl('');
  //   maxTime: DateTime = DateTime.local().set({
  //     hour: 16,
  //   });
  //   minTime: DateTime = DateTime.local().set({
  //     hour: 14,
  //   });
  //   required: boolean = !1;

  //   @ViewChild('timepicker') timepicker: any;

  //   openFromIcon(timepicker: { open: () => void }) {
  //     if (!this.formControlItem.disabled) {
  //       timepicker.open();
  //     }
  //   }

  //   onClear($event: Event) {
  //     this.formControlItem.setValue(null);
  //   }

  @ViewChild("selectresturent") selectresturent: TemplateRef<any>;
  @ViewChild("viewdetails") viewdetails: TemplateRef<any>;
  @ViewChild("ProfilePicCropModal") ProfilePicCropModal: TemplateRef<any>;
  @ViewChild("delivary") delivary: TemplateRef<any>;
  @ViewChild("viewmenudetailsdesh") viewmenudetailsdesh: TemplateRef<any>;


  ngOnInit(): void {

    this.spinner.show();
    this.getProfileDetails();
    this.getClubListAPICall();
    this.getRestaurantNearByAPICall();
    this.getTeamListAPICall();
    // this.upcomingOrdersAPICalll();
    this.getUpcomingOrdersCoach();
    console.log(this.search, "this.searchthis.search");
    console.log("calling fun1 from chatbot");
    chatbot();

    this.currentUser = JSON.parse(this.currentUser);
    this.userType = this.currentUser?.userDetails?.userType ? this.currentUser?.userDetails?.userType : this.currentUser?.userType;

    history.pushState(null, '');

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
      // this.toast.error(`Pleas.`);
    });
    if (window.screen.availWidth < 700) {
      this.upcomingbtn();
    }
  }



  openModal(template: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template, this.config);


  }
  openModalDel(template: TemplateRef<any>) {

    this.modalRef = this.modalService.show(template, this.configDel);


  }
  // DEFAULT END
  // ********************************************************************************************


  // ********************************************************************************************
  // showAccessDialogue END
  // showAccessDialogue(){
  //   try{
  //     const dialogRef = this.dialogue.open(SuccessAccountCreatedComponent, {
  //       hasBackdrop: true,
  //       disableClose: true,
  //       data: {
  //         userType: {
  //           titleOne: 'Admin access required',
  //           text: "Please wait upto 24 hours for addmin access!",
  //           imgPath: '../../../assets/icon/thumb.png',
  //           access : "restric"
  //         }
  //       },
  //     });
  //   }
  //   catch(e){}
  // }
  // showAccessDialogue END
  // ********************************************************************************************


  // ********************************************************************************************
  // onclickNext END

  onclickNext() {
    try {
      console.log(this.eventForm.value, "eventForm");
      this.modalRef.hide();
      this.openModal(this.selectresturent);
    }
    catch (e) { }
  }
  // onclickNext END
  // ********************************************************************************************

  addEvent() {

    this.eventForm.reset();
    for (var i of this.teamList) {
      i['selected'] = false
    }
    for (var i of this.restaurantListNearBy) {
      i['selected'] = false;
    }
    this.deliveryCheckboxSelected = undefined;
    this.pickupCheckboxSelected = undefined;
    this.openModal(this.ProfilePicCropModal);
  }





  onclickview() {
    this.modalRef.hide();
    this.openModal(this.viewdetails);
  }



  onclickback() {
    this.modalRef.hide();
    this.openModal(this.selectresturent)
  }

  onclicknext() {
    this.modalRef.hide();
    this.openModalDel(this.delivary)
  }



  onViewMenuClicked(id: any) {
    // this.router.navigate(['/products', id]);
    this.spinner.show();
    setTimeout(() => {
      this.router.navigate(['/products', id?.restaurantData?._id], { queryParams: { eventId: id?._id, type: 'menu', source: 'dashboard' } });

    }, 500)
  }

  onPlayerOrdersClicked(id: any) {
    this.spinner.show();
    setTimeout(() => {
      this.router.navigate(['/products', id?.restaurantData?._id], { queryParams: { eventId: id?._id, type: 'player', source: 'dashboard' } });

    }, 500)
  }


  onclickmenuback() {
    this.modalRef.hide();
    this.openModal(this.viewdetails)
  }


  // ********************************************************************************************
  // getClubListAPICall END
  selectRestaurantData: any;
  checkRestaurant(e: any, restaurant: any) {
    var id = e.source.value;
    this.selectRestaurantData = restaurant;
    for (var i of this.restaurantListNearBy) {
      if (id == i?._id) {
        i['selected'] = true;
        this.checkedVal = true;
        this.disableRestaurantsNext = true;
      } else {
        i['selected'] = false;
      }
    }
    // this.selectForm.value.check = id;
    this.selectForm.get('check').patchValue(id);
    // e.target.checked==true
    if (e.checked) {
      for (var i of this.restaurantListNearBy) {
        console.log(i);
        if (id == i?._id) {
          i['selected'] = true;
        }
      }
      this.disableRestaurantsNext = true;
    } else {
      for (var i of this.restaurantListNearBy) {
        if (id == i?._id) {
          i['selected'] = false;
        }
      }
      this.disableRestaurantsNext = false;
    }
  }

  teamArr: any = [];

  selectTeams(e: any, id: any) {
    // e.target.checked
    console.log(e?.checked);
    if (e.checked == true) {
      this.teamArr.push(id);
      for (var i of this.teamList) {
        if (i?._id == id) {
          i['selected'] = true
        }
      }
      // console.log(this.teamArr, "ooooo")
    } else {
      this.teamArr = this.teamArr.filter((data: any) => {
        return data != id
      })

      for (var i of this.teamList) {
        if (i?._id == id) {
          i['selected'] = false
        }
      }
      // var index = this.teamArr.indexOf(id);
      // this.teamArr.splice(index, 1);
      // console.log(this.teamArr, "mmm")

    };
    this.eventForm.get('team').patchValue(this.teamArr);

  }
  getClubListAPICall() {
    try {
      this.spinner.show();
      let req_body = {
        page: 1,
        pageLimit: 100,
        // search: this.search
      }
      if (this.search) {
        req_body["search"] = this.search
      }

      let hours: any = new Date().getHours();
      if (hours < 10) {
        hours = `0${hours}`
      }
      let min: any = new Date().getMinutes();
      if (min < 10) {
        min = `0${min}`
      }

      if (this.selected) {
        let month = this.selected._i.month;
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let req = `${months[month]} ${this.selected._i.date}, ${this.selected._i.year}`;
        let selectedDate = new Date(req);
        let selectedDateUTC = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();
        // req_body['selectedDate'] = selectedDateUTC


        let fullDate = new Date(this.selected);
        let date: any = fullDate.getDate();
        if (date < 10) {
          date = `0${date}`
        }

        let monthNew: any = fullDate.getMonth() + 1;
        if (monthNew < 10) {
          monthNew = `0${monthNew}`
        }
        let year = fullDate.getFullYear();


        let currentDate = new Date();
        let date1: any = currentDate.getDate();
        let month1: any = currentDate.getMonth() + 1;
        let year1 = currentDate.getFullYear();
        if (date1 < 10) {
          date1 = `0${date1}`
        }
        if (month1 < 10) {
          month1 = `0${month1}`
        }

        console.log(`${year1}-${month1}-${date1}`, `${year}-${monthNew}-${date}`);

        if (`${year1}-${month1}-${date1}` == `${year}-${monthNew}-${date}`) {
          let dates = new Date(`${year}-${month}-${date} ${currentDate.getHours()}: ${currentDate.getMinutes()}`);
          let utcDateTime = this.datepipe.transform(dates, 'YYYY-MM-dd HH:mm:ss', 'UTC')
          // data['date']= utcDateTime
          req_body['selectedDate'] = 'today';
          req_body['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
        } else {
          req_body['selectedDate'] = selectedDateUTC;
          req_body['currentDate'] = `${selectedDateUTC.split("T")[0]}T${hours}:${min}:00.000Z`;
        }

      } else {
        let dateToday = new Date();
        let yearNow = dateToday.getFullYear();
        let dateNow: any = dateToday.getDate();
        let monthNow: any = dateToday.getMonth() + 1;
        if (dateNow < 10) {
          dateNow = `0${dateNow}`
        }
        if (monthNow < 10) {
          monthNow = `0${monthNow}`
        }
        req_body['currentDate'] = `${yearNow}-${monthNow}-${dateNow}T${hours}:${min}:00.000Z`;
        // req_body['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
      }

      this.clubService.getClubList(req_body).subscribe(
        (res: any) => {
          this.EventList = res?.output?.eventData?.list;
          this.spinner.hide();
        },
        (err: any) => {
          this.spinner.hide();
          // this.toast.error("Error on fetch events");
        }
      )
    }
    catch (e) { }
  }
  // getClubListAPICall END
  // ********************************************************************************************


  // ********************************************************************************************
  // getProfileDetails END
  getProfileDetails() {
    try {
      this.csObj.getProfile().subscribe((res: any) => {
        this.ProfileDetails = res;
        this.spinner.hide();

      })
    }
    catch (e) { }
  }
  // getProfileDetails END
  // ********************************************************************************************


  // ********************************************************************************************
  // onclickAddEvent END

  deleveryTimeVal: any;
  onTimeChange(e) {
    // debugger;
    // var inputEle:any = document.getElementById('myTime');
    // var timeSplit = inputEle.value.split(':'),
    //   hours,
    //   minutes,
    //   meridian;
    // hours = timeSplit[0];
    // minutes = timeSplit[1];
    // if (hours > 12) {
    //   meridian = 'PM';
    //   hours -= 12;
    // } else if (hours < 12) {
    //   meridian = 'AM';
    //   if (hours == 0) {
    //     hours = 12;
    //   }
    // } else {
    //   meridian = 'PM';
    // }
    let timearr = e.toLocaleTimeString('en-US').split(":");

    let hours = timearr[0];
    let minutes = timearr[1];
    let meridian = timearr[2].substring(3);

    console.log(hours + ':' + minutes + ' ' + meridian);

    this.deleveryTimeVal = hours + ':' + minutes + ' ' + meridian
  }


  onclickAddEvent() {
    try {
      this.spinner.show();

      let selectedDateUTC = new Date((new Date(this.eventDetails.date).getTime() - new Date(this.eventDetails.date).getTimezoneOffset() * 60000)).toISOString();

      let request_body = {

        "eventTitle": this.eventForm.value.title,
        "eventDate": selectedDateUTC,
        "deliveryTime": this.deleveryTimeVal,
        "teams": this.teamArr,
        "deliveryMethod": this.delieveryCheckBoxText,
        "restaurantId": this.selectForm.value.check,
        // "eventTime": this.eventForm.value.delivary,
        "comment": this.eventForm.value.comment,
      }

      if (!this.eventForm.value.comment) {
        delete request_body.comment
      }
      this.clubService.addEvent(request_body).subscribe(
        (res: any) => {
          // console.log(res);
          // this.delieveryCheckBoxText = undefined;
          // this.checkedVal = false;
          // this.eventForm.reset();
          // this.selectForm.reset();
          // this.checkForm.reset();
          // this.modalRef.hide();
          // this.deliveryCheckboxSelected = undefined;
          // this.pickupCheckboxSelected = undefined;
          // this.spinner.hide();
          this.reset2();
          this.successCreation();
          // this.spinner.hide();
          this.getClubListAPICall();
        },
        (err: any) => {
          // this.delieveryCheckBoxText = undefined;
          // this.checkedVal = false;
          // this.eventForm.reset();
          // this.selectForm.reset();
          // this.checkForm.reset();
          // this.spinner.hide();
          // this.modalRef.hide();
          // this.deliveryCheckboxSelected = undefined;
          // this.pickupCheckboxSelected = undefined;
          // // this.toast.error("Error on adding events.");
          this.reset2();
        }
      )
    }
    catch (e) { }
  }
  // onclickAddEvent END
  // ********************************************************************************************


  reset2() {
    this.delieveryCheckBoxText = undefined;
    this.checkedVal = false;
    this.eventForm.reset();
    this.selectForm.reset();
    this.checkForm.reset();
    this.modalRef.hide();
    this.deliveryCheckboxSelected = undefined;
    this.pickupCheckboxSelected = undefined;
    this.spinner.hide();
  }
  // ********************************************************************************************
  // getRestaurantNearByAPICall END
  getRestaurantNearByAPICall() {
    try {
      this.spinner.show();
      this.clubService.getRestaurantNearBy().subscribe(
        (res: any) => {
          this.restaurantListNearBy = res.output;
          this.spinner.hide();
          console.log(this.selectForm.value.check, "yyyy")
          if (this.selectForm.value.check === "" || this.selectForm.value.check == undefined) {
            this.disableRestaurantsNext = true
          } else {
            this.disableRestaurantsNext = false
          }

        },
        (err: any) => {
          // this.toast.error("Error on fetching events.");
          this.spinner.hide();
        }
      )
    }
    catch (e) { }
  }
  // getRestaurantNearByAPICall END
  // ********************************************************************************************


  sampleRequestBody = {
    "page": 1,
    "pageLimit": 100,
  }


  // ********************************************************************************************
  // getTeamListAPICall END
  getTeamListAPICall() {
    try {
      let req_body = this.sampleRequestBody;
      console.log(this.sampleRequestBody);
      this.clubService.getTeamList(req_body).subscribe(
        (res: any) => {
          this.teamList = res.output.list;
          this.spinner.hide();
        },
        (err: any) => {
          // this.toast.error("Error on fetch events");
          this.spinner.hide();
        }
      )
    }
    catch (e) { }
  }
  // getTeamListAPICall END
  // ********************************************************************************************


  // ********************************************************************************************
  // searchData END
  searchData() {
    console.log(this.activeView);
    if (this.search.length >= 3 && this.activeView == 'previous') {
      this.getClubListAPICall();
    }

    if (this.search.length >= 3 && this.activeView == 'menu') {
      this.getClubListAPICall();
    }

    if (this.search.length < 3 && this.activeView == 'menu') {
      this.getClubListAPICall();
    }

    if (this.search.length < 3 && this.activeView == 'previous') {
      this.getClubListAPICall();
    }
  }
  // searchData END
  // ********************************************************************************************



  // ********************************************************************************************
  // onclickviewSelectRestro END
  onclickviewSelectRestro(id: any) {
    this.modalRef.hide();
    this.getRestaurantDetailsAPICall(id)

  }
  // onclickviewSelectRestro END
  // ********************************************************************************************


  // ********************************************************************************************
  // getRestaurantDetails Start
  getRestaurantDetailsAPICall(id: any) {
    try {
      this.clubService.getRestaurantDetails(id).subscribe(
        (res: any) => {
          this.restaurantListByUser = res.output;
          this.openModal(this.viewdetails);
          // this.spinner.hide();
        },
        (err: any) => {
          // this.toast.error("Error on fetching restaurant.");
          this.spinner.hide();
        }
      )
    }
    catch (e) { }
  }
  // getRestaurantDetails END
  // ********************************************************************************************


  // ********************************************************************************************
  // selectRestaurantById Start
  selectRestaurantById(id: any, restaurant: any) {
    this.selectRestaurantData = restaurant;
    for (var i of this.restaurantListNearBy) {
      if (id == i?._id) {
        i['selected'] = true;
      } else {
        i['selected'] = false;
      }
    }
    this.disableRestaurantsNext = true;
    try {

      for (let val of this.restaurantListNearBy) {
        if (val._id == id) {
          // this.selectForm.value.check = id;
          this.selectForm.get('check').patchValue(id);
          this.checkedVal = true;
          this.modalRef.hide();
          this.openModal(this.selectresturent)
        }
      }
    }

    catch (e) { }
  }

  closeSelectResto() {
    this.modalRef.hide();
    this.openModal(this.selectresturent)
  }
  // selectRestaurantById END
  // ********************************************************************************************


  // ********************************************************************************************t
  // show restauratn location start
  viewLocation(cords: any) {
    console.log("hell")
    var url = `https://maps.google.com/?q=${cords[1]},${cords[0]}`
    window.open(url, '_blank');
  }
  // show restauratn location END
  // ********************************************************************************************


  // ********************************************************************************************t
  // onclickmenu start
  onclickmenu(id: any) {
    this.getRestaurantProducts(id);
  }
  // onclickmenu END
  // ********************************************************************************************


  // ********************************************************************************************t
  // getRestaurantProducts start
  getRestaurantProducts(id: any) {
    let data = {
      page: 1,
      pageLimit: 1000,
      restaurantId: id,
    }

    this.csObj.getRestauratProducts(data).subscribe((res: any) => {
      if (res.status == 200) {
        this.productsList = res.output.productData.list;
        this.modalRef.hide();
        this.openModal(this.viewmenudetailsdesh)

      }
    })
  }
  // sgetRestaurantProducts END
  // ********************************************************************************************


  // ********************************************************************************************t
  // closeModal start
  closeModal() {
    this.modalRef.hide();
    this.delieveryCheckBoxText = undefined;
    this.checkedVal = false;
    this.eventForm.reset();
    this.selectForm.reset();
    this.checkForm.reset();
  }

  closeSelectRestaurantModal() {
    this.modalRef.hide();
    this.openModal(this.ProfilePicCropModal);
  }

  closeModalDeliveryMethod() {
    this.modalRef.hide();
    this.openModal(this.selectresturent);
  }
  // closeModal END
  // ********************************************************************************************


  // ********************************************************************************************t
  // upcoming orders start

  upcomingOrdersAPICalll() {
    try {
      this.manageOrdersServices.getUpcomingOrders().subscribe(
        (res: any) => {
          console.log(res, "Upcoming orders")
          this.UpcomingOrderList = res.output
        },
        (err: any) => {
          // this.toast.error("Error on fetch orders");
        }
      )
    }
    catch (e) { }
  }

  getUpcomingOrdersCoach() {
    let data = {// "date":"2023-11-21"
    }

    let hours: any = new Date().getHours();
    if (hours < 10) {
      hours = `0${hours}`
    }
    let min: any = new Date().getMinutes();
    if (min < 10) {
      min = `0${min}`
    }

    if (this.selected) {
      let fullDate = new Date(this.selected);
      let date: any = fullDate.getDate();
      if (date < 10) {
        date = `0${date}`
      }

      let month: any = fullDate.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`
      }
      let year = fullDate.getFullYear();



      let currentDate = new Date();
      let date1: any = currentDate.getDate();
      let month1: any = currentDate.getMonth() + 1;
      let year1 = currentDate.getFullYear();
      if (date1 < 10) {
        date1 = `0${date1}`
      }
      if (month1 < 10) {
        month1 = `0${month1}`
      }

      if (`${year1}-${month1}-${date1}` == `${year}-${month}-${date}`) {
        let dates = new Date(`${year}-${month}-${date} ${currentDate.getHours()}: ${currentDate.getMinutes()}`);
        let utcDateTime = this.datepipe.transform(dates, 'YYYY-MM-dd HH:mm:ss', 'UTC')
        // data['date']= utcDateTime
        data['date'] = 'today';
        data['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
      } else {
        data['date'] = `${year}-${month}-${date}`;
        data['currentDate'] = `${year}-${month}-${date}T${hours}:${min}:00.000Z`
      }

    } else {
      data['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
    }
    this.manageOrdersServices.getUpcomingOrdersCoach(data).subscribe((res: any) => {
      if (res.status == 200) {
        this.UpcomingOrderList = res.output
        if (res.output?.length == 0 || res.output?.length == undefined) {
          // this.EventList = []
        }
      }
    })
  }
  // upcoming orders END
  // ********************************************************************************************



  // dilip:any;
  // onchangecolor(id) {
  //   let res:any;
  //   res=true;
  //   (<HTMLInputElement>document.getElementById('image' + id)).style.opacity = '1'
  // }
  upcomingbtn() {
    (<HTMLInputElement>document.querySelector('.upcoming-order-btn')).classList.add('active-nav-dash');
    (<HTMLInputElement>document.getElementById('upcoming-order-sect')).style.display = 'block';
    (<HTMLInputElement>document.getElementById('event-sect')).style.display = 'none';
    (<HTMLInputElement>document.querySelector('.events-btn')).classList.remove('active-nav-dash');

  }

  eventbtn() {
    this.setValues();
    (<HTMLInputElement>document.getElementById('event-sect')).style.display = 'block';
    (<HTMLInputElement>document.querySelector('.upcoming-order-btn')).classList.remove('active-nav-dash');
  }

  setValues() {
    (<HTMLInputElement>document.querySelector('.events-btn')).classList.add('active-nav-dash');
    (<HTMLInputElement>document.getElementById('upcoming-order-sect')).style.display = 'none';
  }

  // add favorite restaurant
  addFavourite(id: any) {

    let src = (<HTMLInputElement>document.getElementById('restaurantId' + id)).src;
    let img = 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled.png';
    if (src == img) {
      let str = "heart-img" + id;
      var elements = document.getElementsByClassName(str);
      console.log(elements);
      for (var i = 0; i < elements.length; i++) {
        console.log(i);
        elements[i].setAttribute("src", 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled (1).png');
        (<HTMLInputElement>document.getElementById('restaurantId' + id)).src = 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled (1).png';
      }
      this.spinner.show();
      this.clubService.removeFavourateResto({ "restaurantId": id }).subscribe((res: any) => {
        if (res.status == 200) {
        }
      })
      this.spinner.hide();
    } else {
      var elements = document.getElementsByClassName("heart-img" + id);
      for (var i = 0; i < elements.length; i++) {
        elements[i].setAttribute("src", 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled.png');
        // (<HTMLInputElement>document.getElementById('restaurantId'+id)).src = 'http://localhost:4200/assets/icons/heart-filled.png';
      }
      this.spinner.show();
      this.clubService.addFavourateResto({ "restaurantId": id }).subscribe((res: any) => {
        if (res.status == 200) {
        }
      })
      this.spinner.hide();
    }
  }


  // remove favorite restaurant
  removeFavourite(id: any) {
    let src = (<HTMLInputElement>document.getElementById('restaurantId' + id)).src;
    if (src == 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled.png') {
      var elements = document.getElementsByClassName("heart-img" + id);
      for (var i = 0; i < elements.length; i++) {
        elements[i].setAttribute("src", 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled (1).png');
      }
      // (<HTMLInputElement>document.getElementById('restaurantId'+id)).src = 'http://localhost:4200/assets/icons/heart-filled (1).png';
      this.spinner.show();
      this.clubService.removeFavourateResto({ "restaurantId": id }).subscribe((res: any) => {
        if (res.status == 200) {
        }
      })
      this.spinner.hide();
    } else {
      var elements = document.getElementsByClassName("heart-img" + id);
      for (var i = 0; i < elements.length; i++) {
        elements[i].setAttribute("src", 'https://gameday-dev-web.approd.ca/assets/icons/heart-filled.png')
        // (<HTMLInputElement>document.getElementById('restaurantId'+id)).src = 'http://localhost:4200/assets/icons/heart-filled.png';
      }
      this.spinner.show();
      this.clubService.addFavourateResto({ "restaurantId": id }).subscribe((res: any) => {
        if (res.status == 200) {
        }
      })
      this.spinner.hide();
    }


  }
  customtime() {
    if (this.eventForm.value.delivary) {
      (<HTMLInputElement>document.getElementById('myTime')).classList.remove('custome-time');
    } else {
      (<HTMLInputElement>document.getElementById('myTime')).classList.add('custome-time');
    }
  }

  onChangeDate(e: any) {
    this.spinner.show();
    let month = e._i.month;
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let req = `${months[month]} ${e._i.date}, ${e._i.year}`;

    // let req = `${months[month]} ${e.getDate()}, ${e.getFullYear()}`;
    let selectedDate = new Date(req);

    // Convert selectedDate to UTC format
    let selectedDateUTC = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();
    // this.clubService.getUpcomingOrderByDate({"page": 1, "pageLimit": 100, "selectedDate": selectedDateUTC}).subscribe((res:any)=>{
    //   if(res.status == 200){
    //     this.UpcomingOrderList = res.output.list
    //   }
    // })

    this.getUpcomingOrdersCoach();
    this.getClubListAPICall();
    this.spinner.hide();
  }

  convertToMiles(data) {
    let res = parseInt(data) * 0.621371;
    return res
  }

  clearFilter() {
    this.search = undefined;
    this.selected = undefined;
    this.getClubListAPICall();
  }

  checkResolution(data: any) {
    let width = window.innerWidth;
    if (width <= 999) {
      if (data.length > 25) {
        return data.slice(0, 25) + '...'
      } else {
        return data
      }
    } else if (width > 999) {
      if (data.length > 35) {
        return data.slice(0, 35) + '...'
      } else {
        return data
      }
    }
  }

  onClosed() {
    // formControl.control.markAsTouched();
  }

  eventDetails;
  selectedRestaurantDetails;
  deliveryMethod;
  getEventFormData(data) {
    console.log(data);
    this.eventDetails = data.eventDetails;
    this.deleveryTimeVal = data.deleveryTimeVal;
    this.modalRef.hide();
    this.openModal(this.selectresturent);
  }

  getSelectRestaurantFormData(data) {
    this.modalRef.hide();
    this.selectedRestaurantDetails = data;
    this.selectRestaurantData = data.selectRestaurantData;
    this.selectForm.get('check').patchValue(data.selectForm.check);
    this.openModalDel(this.delivary);
  }

  getRestaurantDetails(id) {
    this.modalRef.hide();
    this.getRestaurantDetailsAPICall(id);
  }

  closeSelectRestaurantPopup() {
    this.modalRef.hide();
    this.openModal(this.selectresturent);
  }

  selectedRestaurant(data) {
    // this.selectRestaurantById(data.id,data.restaurant);
    console.log(data);
    let id = data.id;
    let restaurant = data.restaurant;
    this.selectedRestaurantDetails = { restaurant, id };
    // this.selectRestaurantData = restaurant;
    // for(var i of this.restaurantListNearBy){
    //   if(id == i?._id){
    //     i['selected']= true;
    //   }else{
    //     i['selected']= false;
    //   }
    // }
    // // this.disableRestaurantsNext = true;

    // for (let val of this.restaurantListNearBy) {
    //   if (val._id == id) {
    //     // this.selectForm.value.check = id;
    this.selectForm.get('check').patchValue(id);
    this.checkedVal = true;
    this.modalRef.hide();
    this.openModal(this.selectresturent)
    //   }
    // }

    // this.selectForm.get('check').patchValue(data.id);
  }

  clickAddEvent(data) {
    // console.log(data);
    // this.deliveryMethod = data;
    // console.log("Let's create the event with all the data");
    this.createEvent(data);
  }

  req_body: any = {};
  // createEvent(data) {
  //   this.deliveryMethod = data;
  //   try {
  //     this.spinner.show();


  //     // let req_body = {

  //     //   "eventTitle": this.eventDetails.title,
  //     //   "eventDate": this.datepipe.transform(this.eventDetails.date, 'dd-MMM-YYYY'),
  //     //   "deliveryTime": this.deleveryTimeVal,
  //     //   "teams": this.eventDetails.team,
  //     //   "deliveryMethod": this.deliveryMethod,
  //     //   "restaurantId": this.selectForm.value.check,
  //     //   // "eventTime": this.eventForm.value.delivary,
  //     //   "comment": this.eventDetails.comment,
  //     // }


  //     // console.log((new Date(this.eventDetails.date).toISOString()),"UTC Date");

  //     let selectedDateUTC = new Date((new Date(this.eventDetails.date).getTime() - new Date(this.eventDetails.date).getTimezoneOffset() * 60000)).toISOString();

  //     this.req_body["eventTitle"] = this.eventDetails.title;
  //     // this.req_body["eventDate"] = this.datepipe.transform(this.eventDetails.date, 'dd-MMM-YYYY');
  //     this.req_body["eventDate"] = selectedDateUTC;
  //     this.req_body["deliveryTime"] = this.deleveryTimeVal;
  //     this.req_body["teams"] = this.eventDetails.team;
  //     this.req_body["deliveryMethod"] = this.deliveryMethod;
  //     this.req_body["restaurantId"] = this.selectForm.value.check;
  //       // "eventTime": this.eventForm.value.delivary,
  //     this.req_body["comment"] = this.eventDetails.comment;
  //     let hours = this.deleveryTimeVal?.split(":")[0];
  //     let minutes = this.deleveryTimeVal?.split(":")[1]?.split(" ")[0];

  //     let eventDateTime:any = new Date(selectedDateUTC);
  //     eventDateTime.setHours(parseInt(hours));
  //     eventDateTime.setMinutes(parseInt(minutes));


  //     let eventDate = new Date(selectedDateUTC);
  //     let year = eventDate.getFullYear();
  //     let month:any = eventDate.getMonth()+1;
  //     let date:any =  Number(this.req_body.eventDate.split("T")[0].split("-")[2]);
  //     // let date:any =  eventDate.getDate();

  //     if(month <10){
  //       month = `0${month}`
  //     }
  //     if(date <10){
  //       date = `0${date}`
  //     }

  //     let newDateTime = `${year}-${month}-${date} ${this.deleveryTimeVal}`;



  //     if(this.deleveryTimeVal?.split(":")[1]?.split(" ")[1]=='AM'){
  //       eventDateTime.setHours(eventDateTime.getHours() - 12);
  //     }

  //     // this.req_body["eventDateTime"] = eventDateTime;
  //     this.req_body["eventDateTime"] = this.datepipe.transform(newDateTime, 'YYYY-MM-dd HH:mm:ss', 'UTC');



  //     if (!this.eventDetails.comment) {
  //       delete this.req_body["comment"];
  //     }
  //     this.clubService.addEvent(this.req_body).subscribe(
  //       (res: any) => {
  //         console.log(res);
  //         this.reset();
  //         this.successCreation();
  //       },
  //       (err: any) => {
  //         this.reset();
  //         // this.delieveryCheckBoxText = undefined;
  //         // this.checkedVal = false;
  //         // this.eventForm.reset();
  //         // this.selectForm.reset();
  //         // this.checkForm.reset();
  //         // this.spinner.hide();
  //         // this.modalRef.hide();
  //         // this.deliveryCheckboxSelected = undefined;
  //         // this.pickupCheckboxSelected = undefined;
  //         // this.toast.error("Error on adding events.");
  //       }
  //     )
  //   }
  //   catch (e) { }
  // }



  createEvent(data) {
    this.deliveryMethod = data;

    try {
      this.spinner.show();

      // Parse delivery time ("hh:mm AM/PM")
      const [timePart, meridian] = this.deleveryTimeVal.split(" ");
      const [hoursStr, minutesStr] = timePart.split(":");
      let hours = parseInt(hoursStr, 10);
      const minutes = parseInt(minutesStr, 10);

      if (meridian === 'PM' && hours < 12) hours += 12;
      if (meridian === 'AM' && hours === 12) hours = 0;

      // Combine date and time as LOCAL time
      const localDateTime = new Date(this.eventDetails.date); // Local date
      localDateTime.setHours(hours, minutes, 0, 0); // Set local time

      // eventDate should be UTC midnight of the selected date
      const utcMidnight = new Date(this.eventDetails.date);
      utcMidnight.setHours(0, 0, 0, 0); // Local midnight
      const eventDateUTC = new Date(utcMidnight.getTime() - utcMidnight.getTimezoneOffset() * 60000);

      // Build request body
      this.req_body["eventTitle"] = this.eventDetails.title;
      this.req_body["eventDate"] = eventDateUTC.toISOString(); // UTC midnight
      this.req_body["deliveryTime"] = this.deleveryTimeVal;
      this.req_body["teams"] = this.eventDetails.team;
      this.req_body["deliveryMethod"] = this.deliveryMethod;
      this.req_body["restaurantId"] = this.selectForm.value.check;
      this.req_body["eventDateTime"] = localDateTime.toISOString(); // Local time auto converted to UTC

      if (this.eventDetails.comment) {
        this.req_body["comment"] = this.eventDetails.comment;
      }

      this.clubService.addEvent(this.req_body).subscribe(
        (res: any) => {
          console.log(res);
          this.reset();
          this.successCreation();
        },
        (err: any) => {
          this.reset();
        }
      );

    } catch (e) {
      console.error("Error creating event:", e);
    }
  }








  closeAddEventPopup() {
    this.modalRef.hide();
  }

  reset() {
    this.delieveryCheckBoxText = undefined;
    this.checkedVal = false;
    this.eventForm.reset();
    this.selectForm.reset();
    this.checkForm.reset();
    this.modalRef.hide();
    this.deliveryCheckboxSelected = undefined;
    this.pickupCheckboxSelected = undefined;
    this.spinner.hide();
    this.getClubListAPICall();
  }
}


